module.exports = __webpack_public_path__ + "img/007.f4505a2b.jpg";